import Vue from 'vue';
import { HideSlidesStorageService } from "../../Services/hideSlidesStorageService";

export function createHideSlides(lessonPlanController) {
	return new Vue({
		data() {
			return {
				isShowingSelectionBoxes: false,
				areHidden: false,
				selectedSlidesIds: [],
				hideSlidesStorage: null
			};
		},
		created() {
			this.hideSlidesStorage = new HideSlidesStorageService(this.getStorageKey());
			this.selectedSlidesIds = this.hideSlidesStorage.load();
			lessonPlanController.setHideSlidesService(this);
		},
		methods: {
			isEmptyHiddenSlides() {
				return this.selectedSlidesIds.length === 0;
			},
			toggleHideSlides() {
				this.areHidden = !this.areHidden;
			},
			toggleHideSlidesSelectionBoxes() {
				this.isShowingSelectionBoxes = !this.isShowingSelectionBoxes;
			},
			getDifferenceIds(source, target) {
				const targetSet = new Set(target);
				return source.filter(id => !targetSet.has(id));
			},
			setHasToHideSlideProperty(slide, value) {
				slide.hasToHideSlide = value;

				if (!Array.isArray(slide.children)) {
					return;
				}

				const childIds = slide.children.map(child => child.id);

				if (value) {
					this.selectedSlidesIds = [...new Set([...this.selectedSlidesIds, ...childIds])];
				} else {
					const childIdsSet = new Set(childIds);

					this.selectedSlidesIds = this.selectedSlidesIds.filter(id => !childIdsSet.has(id));
				}
			},
			getAffectedIds(newIds, oldIds, areAddingIds) {
				if (areAddingIds) {
					return this.getDifferenceIds(newIds, oldIds);
				}

				return this.getDifferenceIds(oldIds, newIds);
			},
			getStorageKey() {
				const { contentId, revision } = lessonPlanController.getLocator();

				return `hideSlides-${contentId}-${revision}`;
			}
		},
		watch: {
			selectedSlidesIds: {
				handler(newIds, oldIds) {
					this.hideSlidesStorage.save(newIds);
					const areAddingIds = newIds.length > oldIds.length;

					const affectedIds = this.getAffectedIds(newIds, oldIds, areAddingIds);
					affectedIds.forEach(affectedId => {
						const affectedSlide = lessonPlanController.getSlideFromSlideId(affectedId);

						if (affectedSlide) {
							this.setHasToHideSlideProperty(affectedSlide, areAddingIds);
						}
					});

					lessonPlanController.navigation.refreshSlideArray();
				}
			}
		}
	});
}